module.exports = __webpack_public_path__ + "img/firmbee-com-SpVHcbuKi6E-unsplash.2e89b296.jpeg";